import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const TeethOutline = createIcon({
  displayName: 'TeethOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.67 7.271c-1.092.307-2.248.307-3.34 0"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.282 6.414v0c-1.153-1.922-3.45-2.835-5.608-2.228l-.954.268c-.471.132-.969.132-1.439 0l-.954-.268c-2.159-.607-4.455.306-5.609 2.228v0c-.465.775-.711 1.662-.712 2.567v.093c-.004 3.074.615 6.117 1.818 8.946l.328.77c.312.733 1.033 1.21 1.831 1.21v0c.815 0 1.548-.498 1.849-1.255l.949-2.39c.199-.502.682-.831 1.219-.831v0c.537 0 1.02.329 1.219.831l.949 2.39c.301.757 1.034 1.255 1.849 1.255v0c.798 0 1.519-.477 1.831-1.211l.328-.77c1.204-2.829 1.822-5.872 1.818-8.946v-.093c-.001-.904-.247-1.791-.712-2.566Z"
        ></path>
      </g>
    </>
  ),
})

const TeethTwoTone = createIcon({
  displayName: 'TeethTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none" color="twoToneStrokeColor">
        <Box
          as="path"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.282 6.414v0c-1.153-1.922-3.45-2.835-5.608-2.228l-.954.268c-.471.132-.969.132-1.439 0l-.954-.268c-2.159-.607-4.455.306-5.609 2.228v0c-.465.775-.711 1.662-.712 2.567v.093c-.004 3.074.615 6.117 1.818 8.946l.328.77c.312.733 1.033 1.21 1.831 1.21v0c.815 0 1.548-.498 1.849-1.255l.949-2.39c.199-.502.682-.831 1.219-.831v0c.537 0 1.02.329 1.219.831l.949 2.39c.301.757 1.034 1.255 1.849 1.255v0c.798 0 1.519-.477 1.831-1.211l.328-.77c1.204-2.829 1.822-5.872 1.818-8.946v-.093c-.001-.904-.247-1.791-.712-2.566Z"
        ></Box>
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.67 7.271c-1.092.307-2.248.307-3.34 0"
        ></path>
      </Box>
    </>
  ),
})

const Teeth: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={TeethTwoTone} {...props} />
  default:
    return <CustomIcon as={TeethOutline} {...props} />
  }
}

export default memo(Teeth)
